var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#ED1D24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2699 13.7177C31.9849 12.6479 31.145 11.8055 30.0784 11.5196C28.1454 11 20.394 11 20.394 11C20.394 11 12.6426 11 10.7095 11.5196C9.64299 11.8055 8.80301 12.6479 8.51797 13.7177C8 15.6567 8 19.7021 8 19.7021C8 19.7021 8 23.7476 8.51797 25.6867C8.80301 26.7564 9.64299 27.5988 10.7095 27.8848C12.6426 28.4043 20.394 28.4043 20.394 28.4043C20.394 28.4043 28.1454 28.4043 30.0784 27.8848C31.145 27.5988 31.9849 26.7564 32.2699 25.6867C32.7879 23.7476 32.7879 19.7021 32.7879 19.7021C32.7879 19.7021 32.7879 15.6567 32.2699 13.7177Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8594 23.376L24.338 19.7032L17.8594 16.03V23.376Z",
    fill: "#ED1D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4560221cd5ab1aa0d146f7d5b5a56161.svg";
export { ForwardRef as ReactComponent };